<template>
  <div style="background-color: #fff">
    <div class="fincal-content">
      <p class="" style="margin-top: 5%">
        <span>Category</span>
      </p>
      <h1 class="pageshead">Company News & Blogs</h1>
      <div class="nextewnzheng" @click="gotoarticle('teams')">
        <div class="nectar-video-inner nectar-video-innertwo">
          <div
            class="row-bg-overlay row-bg-layertwo"
            style="background-color: #000000; opacity: 0.3"
          ></div>

          <div class="video-content">
            <div class="video-content-left" style="top: 33%">
              <div class="huibutton">Company News & Blogs</div>
              <h3 style="color: #fff; width: 60%">
              The Best Six Key Challenges of Business Intelligence for IT Teams 2024
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div class="nextewnzheng" @click="gotoarticle('analytics')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-legal"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
                 How Data Science is Different From Data Analytics
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="nextewnzheng" @click="gotoarticle('transform')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-business"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
                How Does Business Intelligence (BI) Transform Data
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nextewnzheng" @click="gotoarticle('organization')">
        <div
          class="nectar-video-inner nectar-video-innertwo nectar-video-intelligence"
        >
          <div
            class="row-bg-overlay row-bg-layertwo"
            style="background-color: #000000; opacity: 0.3"
          ></div>

          <div class="video-content">
            <div class="video-content-left" style="top: 33%">
              <div class="huibutton">Company News & Blogs</div>
              <h3 style="color: #fff; width: 90%">
             How Can Business Intelligence Help an Organization
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div class="nextewnzheng" @click="gotoarticle('utilizing')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-simplify"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
               Utilizing Business Analytics for Risk Management
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="nextewnzheng" @click="gotoarticle('artificial')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-strategies"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
                 Transformative Power of Artificial Intelligence in Business Intelligence
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nextewnzheng" @click="gotoarticle('growth')">
        <div
          class="nectar-video-inner nectar-video-innertwo nectar-video-build"
        >
          <div
            class="row-bg-overlay row-bg-layertwo"
            style="background-color: #000000; opacity: 0.3"
          ></div>

          <div class="video-content">
            <div class="video-content-left" style="top: 33%">
              <div class="huibutton">Company News & Blogs</div>
              <h3
                style="color: #fff; width: 90%"
                @click="gotoarticle('choosing')"
              >
               BI for Market Expansion: Strategies for Global Growth
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-center">
        <div class="nextewnzheng" @click="gotoarticle('adapting')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-effective"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
                 Agile BI: Adapting to Change in a Rapidly Evolving Business Environment
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="nextewnzheng" @click="gotoarticle('transformative')">
          <div
            class="nectar-video-inner nectar-video-innertwo nectar-video-association"
          >
            <div
              class="row-bg-overlay row-bg-layertwo"
              style="background-color: #000000; opacity: 0.3"
            ></div>

            <div class="video-content">
              <div class="video-content-left" style="top: 33%">
                <div class="huibutton">Company News & Blogs</div>
                <h3 style="color: #fff; width: 90%">
                 Transformative Power of Artificial Intelligence in Business Intelligence
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div class="next">
        <span class="next-noactive"  @click="gotoarticle('companypages')">
            1
        </span>
          <span class="next-page" >2</span>
            <span class="next-noactive"  @click="gotoarticle('companypagestree')">3</span>
            <span class="next-noactive" @click="gotoarticle('next')">next</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
    //   '$route.hash': function() {
    //     // 在这里可以处理hash变化后的逻辑
    //   this.scrollToAnchor()
    //   }
  },
  methods: {
    //  scrollToAnc
        gotoarticle(route) {
     
      if(route=='next'){
        if(this.$route.name=='companypagestwo'){
  this.$router.push({ name: 'companypagestree' });
        }
      
  
      }else{
         this.$router.push({ name: route });
      }
    // 
      // window.location.hash = "#about#top";
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.scrollToAnchor()
  },
};
</script>

<style scoped>
ol,
ul {
  margin-left: 30px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.focus {
  position: relative;
}
h2 {
  font-family: Alegreya Sans;
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  margin: 7px 0px;
}

head {
}
h3 {
  font-family: Alegreya Sans;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  /* color: #3d7cbf; */
  text-align: left;
  margin-bottom: 8px;
  margin-top: 10px;
}
.nectar-video-bg {
  height: 100%;
  position: relative;
  top: -25%;
}
.Financial-text {
  padding: 0 20px;
  border-left: 1px solid #ccc;
  color: #fff;
}
.fincalrouter {
  color: #1290c9;
}
.fincal-content {
  margin: auto;
  width: 88%;
  padding: 80px 0px;
  font-size: 18px;
}
.fincal-head {
  padding-bottom: 27px;
}
.fincal-wenzi {
   font-family: "Roboto" !important;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
.wenzhang {
  color: #fff;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  width: 200px;
  margin: auto;
  margin-top: -50px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.wenzhangtwo {
  color: #fff;
  padding: 6px;
  font-size: 18px;
  margin: auto;
}
.nectar-video-innertwo {
  height: 290px;
  background-image: url("../assets/2024/03/IT-Teams.jpg");
  background-position-y: 431px;
  transition: transform 0.42s ease;
  background-size: 100%;
  position: relative;
}
.nectar-video-legal {
  background-image: url("../assets/2024/03/Data-Science-is-Different-From-Data-Analytics.jpg");
  background-position-y: 0px;
}
.nectar-video-business {
  background-image: url("../assets/2024/02/Downloader.la-65dcdeef57626.jpg");
  background-position-y: 10px;
  background-size: 140%;
}
.nectar-video-intelligence {
  background-image: url("../assets/2024/02/Downloader.la-65d4f4ea3261f.jpg");
  background-position-y: -100px;
  background-size: 100%;
}
.nectar-video-simplify {
  background-image: url("../assets/2024/01/blog_using-business-analytics-risk-performance-mgmt_featured-img_730x270_small.jpg");

  background-position-y: 0px;
  background-size: 100%;
}
.nectar-video-strategies {
  background-image: url("../assets/2024/01/artificial-intelligence-leadership.webp");
  background-position-y: 0px;
  background-size: 100%;
}
.nectar-video-build {
  background-image: url("../assets/2024/01/637754fa4d68476a94053449_international-expansion-strategies-p-1600.webp");
  background-position-y: 0px;
  background-size: 100%;
}
.nectar-video-effective {
   background-image: url("../assets/2024/01/1_QtskibYOKxMA-8ybZxUW6w.jpg");
  background-position-y: 0px;
  background-size: 100%;
}
.nectar-video-association {
  background-image: url("../assets/2024/01/bi-business-intelligence.png");
  background-position-y: 0px;
  background-size: 100%;
}
.nectar-video-loan {
  background-image: url("../assets/2024/01/download.png");
  background-position-y: 0px;
  background-size: 100%;
  background-color: #1290c9;
}
.nextewnzheng {
  overflow: hidden;
  width: 65%;
}
.nextewnzheng {
  transition: transform 0.42s ease;
}

.nextewnzheng:hover .nectar-video-innertwo {
  cursor: pointer;
  transform: scale(1.1);
  transition: transform 0.42s ease;
}
.nextewnzheng :hover .row-bg-layertwo {
  opacity: 0.1 !important;
}
@media screen and (max-width: 500px) {
  .video-content-title {
    font-size: 51px;
  }
    .nextewnzheng{
    width: 100% !important;
  }
  .video-content-left h3{
    width: 100% !important;
  }
  .flex-center{
   flex-wrap: wrap !important;
   width: 100% !important;
  }

    h3{
      font-size: 23px !important;
    }
      .pageshead {
      font-size: 53px !important;
      line-height: 52px !important;
    }
}
.pageshead {
  font-family: Alegreya Sans;
  font-size: 82px;
  line-height: 92px;
  font-weight: 500;
  padding-bottom: 36px;
  border-bottom: 1px solid #ccc;
  margin-bottom: 40px;
}
.video-content-left {
  position: absolute;
  top: 49%;
  left: 6%;
}
.flex-center {
  display: flex;
  justify-content: space-between;
  width: 65%;
}
.flex-center .nextewnzheng {
  width: 49%;
  margin: 20px 0px;
}
.next-noactive{
    padding: 20px;
}
.next-page{
       padding: 8px 10px;
       background-color: #1290c9 ;
       border-radius: 5px;
       color: #fff;
         cursor: pointer;
}
.next{
    padding: 50px;
      cursor: pointer;
}
</style>